module.exports = __webpack_public_path__ + "static/media/bag-sm.154da448.jpg";